import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryTimerAltSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M7.9987 1.33301C11.6806 1.33301 14.6654 4.31777 14.6654 7.99967C14.6654 11.6815 11.6806 14.6663 7.9987 14.6663C4.3168 14.6663 1.33203 11.6815 1.33203 7.99967H2.66536C2.66536 10.9452 5.05318 13.333 7.9987 13.333C10.9442 13.333 13.332 10.9452 13.332 7.99967C13.332 5.05415 10.9442 2.66634 7.9987 2.66634C6.16551 2.66634 4.54834 3.59123 3.58837 4.99983L5.33203 4.99967V6.33301H1.33203V2.33301H2.66536L2.66529 3.99913C3.88159 2.38017 5.81785 1.33301 7.9987 1.33301ZM8.66536 4.66634L8.66523 7.72301L10.8271 9.88527L9.8843 10.8281L7.3319 8.27501L7.33203 4.66634H8.66536Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default TaskHistoryTimerAltSVG;
